import { Icon, MenuDropdownItem } from 'hfs-common-ui';
import React, { useCallback } from 'react';
import * as S from './styled';

export interface Props {
  selected?: boolean;
  onClick: (menu: MenuDropdownItem) => void;
  menuItem: MenuDropdownItem;
  mainMenu?: boolean;
}

const MobileMenuDropdownItem = ({ selected = false, onClick, menuItem, mainMenu }: Props) => {
  const { label, iconLeft, iconRight } = menuItem;
  const handleOnClick = useCallback(() => {
    onClick(menuItem);
  }, [menuItem, onClick]);

  return (
    <S.MenuItem $isSelected={selected} onClick={handleOnClick}>
      <S.Shield>
        <S.ShieldEdge>
          <path d="M 4.5342 3.669 C 4.8351 4.0289 5 4.483 5 4.9521 L 5 6 L 0 6 L -0 1.002 C -0 0.0676 1.1676 -0.3563 1.7671 0.3605 L 4.5342 3.669 Z" />
        </S.ShieldEdge>
        <S.ShieldCenter data-testid="dropdownMenuShield" />
        <S.ShieldEdge>
          <path d="m 4.534 2.331 c 0.301 -0.36 0.466 -0.814 0.466 -1.283 l 0 -1.048 l -5 0 l 0 4.998 c 0 0.934 1.168 1.358 1.767 0.642 l 2.767 -3.309 z" />
        </S.ShieldEdge>
      </S.Shield>
      {iconLeft && (
        <S.IconWrapper $placement="left" data-testid="navMenuItemIconLeft">
          <Icon type={iconLeft} />
        </S.IconWrapper>
      )}
      <S.MenuLabel $smallPadding={mainMenu}>{label}</S.MenuLabel>
      {iconRight && (
        <S.IconWrapper $placement="right" data-testid="navMenuItemIconRight">
          <Icon type={iconRight} />
        </S.IconWrapper>
      )}
    </S.MenuItem>
  );
};

export default MobileMenuDropdownItem;
